// extracted by mini-css-extract-plugin
export var bottomRightDock = "_27-0";